import { createSelector } from '@ngrx/store';
import { selectDashboardState } from '../dashboard.selectors';
import * as fromStudyResearcher from '../study-researcher/study-researcher.reducer';

export const selectStudyResearcherState = createSelector(
  selectDashboardState,
  (dashboard) => dashboard?.studyResearcher
);

export const selectIsLoadingStudyResearcher = createSelector(
  selectStudyResearcherState,
  (studyResearcherState) => studyResearcherState?.loadingResearcher
);

export const selectStudyResearcherLoaded = createSelector(
  selectStudyResearcherState,
  (interventionState) => interventionState?.researcherLoaded
);

export const selectSelectedStudyResearcher = createSelector(
  selectStudyResearcherState,
  (interventionState) => interventionState?.selectedResearcher
);

export const selectNewStudyResearcher = createSelector(
  selectStudyResearcherState,
  (interventionState) => interventionState?.newResearcher
);

export const selectIsSingleResearcherVisible = createSelector(
  selectStudyResearcherState,
  (interventionState) => interventionState?.singleResearcherVisible
);

export const selectPrivilegesOpened = createSelector(
  selectStudyResearcherState,
  (interventionState) => interventionState?.privilegesOpened
);

export const selectStudyResearchers = createSelector(selectStudyResearcherState, fromStudyResearcher.selectAll);
